import '../../vendors/template_engine/template_engine'

import { currentDevice } from '../../core/utils/currentDevice'
import Modal from '../../shared/modal/modal'
import on from '../../utils/events_delegation'
import { createBottomSheet } from '../bottom_sheet/bottom_sheet'

const MODAL_ID = 'shared-block'

function activateShareBtn2() {
  const $lightbox = $(`#${MODAL_ID}`)

  const onModalShow = triggerElement => {
    const $share_facebook_element = $lightbox.find('.share-facebook')
    const $share_twitter_element = $lightbox.find('.share-twitter')
    const $form_search_title = $lightbox.find('.form-search-title')
    const $share_list_mail = $lightbox.find('.share-list .mail')
    const $share_list_whatsapp = $lightbox.find('.share-list .whatsapp')
    const $share_list_sms = $lightbox.find('.share-list .sms')
    const $mail_to_data = `mailto:?body=${triggerElement.data('hotel-name')} ${triggerElement.data('description')}%0A${triggerElement.data('url')}`

    $share_facebook_element.attr('data-url', triggerElement.data('url'))
    $share_facebook_element.attr(
      'data-quote',
      `${triggerElement.data('hotel-name')} ${triggerElement.data('description')}`
    )
    $share_twitter_element.attr('data-url', triggerElement.data('url'))
    $share_twitter_element.attr(
      'data-quote',
      `${triggerElement.data('hotel-name')} ${triggerElement.data('description')}`
    )
    $lightbox.find('.share-email').attr('href', $mail_to_data)
    $form_search_title.addClass('hidden')
    $(
      `<p class="form-title form-search-title-base t-highlight mb-1">${triggerElement.data('lightbox-title')}</p>`
    ).insertAfter($form_search_title)

    $share_list_mail.attr('href', $mail_to_data)
    $share_list_whatsapp.attr(
      'href',
      `whatsapp://send?text=${triggerElement.data('hotel-name')} ${triggerElement.data('description')}\n${triggerElement.data('url')}`
    )

    const chrt = IB.lastSearchesCards.getMobileOperatingSystem() === 'ios' ? '&' : '?'

    $share_list_sms.attr(
      'href',
      `sms:///${chrt}body=${triggerElement.data('hotel-name')} ${triggerElement.data('description')}\n${triggerElement.data('url')}`
    )
    $lightbox
      .find('textarea[name=shared-subject]')
      .text(`${triggerElement.data('hotel-name')} ${triggerElement.data('description')} ${triggerElement.data('url')}`)
    $lightbox.find('#url-hidden-input').val(triggerElement.data('url'))
    $lightbox.find('.copy button').removeClass('selected').attr('data-clipboard-text', triggerElement.data('url'))

    drawOffer2($('.shared-block'), triggerElement)

    $('.shared-block').addClass('base').find('.social-share-list').addClass('base')
  }

  if (currentDevice.isMobile) {
    // --------------------------------------------------
    // SHARE BOTTOM SHEET
    // --------------------------------------------------
    let shareBottomSheet
    on({
      eventName: 'click',
      selector: `.js-share-base`,
      handler: e => {
        e.preventDefault()
        if (!shareBottomSheet) {
          shareBottomSheet = createBottomSheet({
            sheetId: MODAL_ID,
          })
        }
        shareBottomSheet.show(() => {
          onModalShow($(e.target))

          // content may have changed, so height needs to be recalculated
          shareBottomSheet.calcInitialSheetHeight()
        })
      },
    })
  } else {
    // --------------------------------------------------
    // SHARE MODAL
    // --------------------------------------------------
    $(document).on('click', '.js-share-base', function (e) {
      const $this = $(this)
      e.preventDefault()
      $('body').addClass('offer-shareable')

      Modal.show(MODAL_ID, {
        onShow: () => {
          onModalShow($this)
        },
        onClose: () => {},
        awaitCloseAnimation: true,
      })
    })
  }
}

function drawOffer2($shared_block, $el) {
  const $desc_cnt = $shared_block.find('.desc-cnt')
  const $desc = $desc_cnt.find('.desc-card')
  const template = $('#modal-desc-card-template').html()

  $desc.remove()

  const template_options = {
    image: $el.data('image'),
    title: $el.data('hotel-name'),
    description: $el.attr('data-description'),
  }
  $desc_cnt.append(TemplateEngine(template, template_options))
  $desc_cnt.find('.desc.desc-share').remove()
  $desc_cnt.find('.desc-title:not(.static)').remove()
}

document.addEventListener('DOMContentLoaded', function () {
  activateShareBtn2()

  const getWindowOptions = function () {
    return ['resizable,scrollbars,status', 'height=350', 'width=350'].join()
  }

  $(document)
    .on('click', '.shared-block.base .share.share-facebook', function (e) {
      e.preventDefault()

      $.fancybox.close()

      const $this = $(this)
      const url = $this.data('url')
      const title = encodeURIComponent($this.data('quote'))

      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}`,
        'facebookwindow',
        getWindowOptions()
      )

      return false
    })
    .on('click', '.shared-block.base .share.share-twitter', function (e) {
      e.preventDefault()

      const $this = $(this)
      const url = $this.data('url')
      const title = encodeURIComponent($this.data('quote'))

      window.open(`https://twitter.com/intent/tweet?text=${title}&url=${url}`, 'ShareOnTwitter', getWindowOptions())
    })
})
